import { render, staticRenderFns } from "./moneyTransferModal.vue?vue&type=template&id=1eafbca8&"
import script from "./moneyTransferModal.vue?vue&type=script&lang=js&"
export * from "./moneyTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports